<template lang="html">
  <div class="row d-flex ">
<div class="col-12 mt-4 d-flex">
  <MDBCard text="center">
    <MDBCardBody class="flex-column d-flex">
      <MDBCardTitle tag="h2" class="text-uppercase h3">Rufen Sie uns direkt an</MDBCardTitle>
      <MDBCardText>
        <p>Nicht lange zögern. Rufen Sie uns an und wir können gerne einen Besichtigungstermin vereinbaren und alle wichtigen Details besprechen.</p>
        <a class="h2" href="tel:+4915730438580" title="Anrufen">015730438580</a>
      </MDBCardText>
      <MDBBtn class="mt-auto" tag="a" href="tel:+4915730438580" title="Anrufen" color="primary" size="lg"><MDBIcon icon="phone" size="1x" /> <span> </span>015730438580</MDBBtn>
    </MDBCardBody>
  </MDBCard>
</div>
<div class="col-12 mt-4 d-flex">
  <MDBCard text="center">
    <MDBCardBody class="flex-column d-flex">
      <MDBCardTitle tag="h2" class="text-uppercase h3">Angebot online anfordern</MDBCardTitle>
      <MDBCardText>
        <p>Sie können gemütlich und unverbindlich ein Online-Formular ausfüllen und alle wichtigen Details zu Ihrer Entrümpelung eingeben.
        Wir berechnen ein Angebot und senden es Ihnen zu.</p>
      </MDBCardText>
      <router-link alt="Entrümpelung Angebot einholen" title="Entrümpelung Angebot einholen" :to="{ name: 'requestform-entruempelung' }" class="mt-auto btn btn-primary btn-lg"><MDBIcon icon="clipboard-list" size="1x" /> <span> </span>Jetzt Angebot anfordern</router-link>
    </MDBCardBody>
  </MDBCard>
</div>
</div>
</template>

<script>
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn, MDBIcon } from 'mdb-vue-ui-kit'

export default {
  name: "ContactButtonsEntruempelungSidebar",
  components: {
    MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn, MDBIcon
  }
}
</script>

<style lang="css" scoped>
</style>
